import { METHOD } from '../utils/Constant';
import { URL } from '../utils/Config';
import { getApiClient, getFullAuthHeaders } from './base';
export const getLeadList = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAD_API_URL
  )({
    method: METHOD.POST,
    url: URL.LEAD_LIST,
    data,
  });
};

export const createLead = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAD_API_URL
  )({
    method: METHOD.POST,
    url: URL.CREATE_LEAD,
    data,
  });
};

export const getLeadDetails = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAD_API_URL
  )({
    method: METHOD.GET,
    url: URL.LEAD_DETAILS,
    params,
  });
};

export const updateAssignLead = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAD_API_URL
  )({
    method: METHOD.POST,
    url: URL.ASSIGN_LEAD,
    data,
  });
};

export const updateLeadStatus = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAD_API_URL
  )({
    method: METHOD.PATCH,
    url: URL.LEAD_STATUS_UPDATE,
    data,
  });
};
